if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        // Kalvessa speedfix 2026-10-20: show the bar only while neither the bundle widget nor the main
        // Add-to-cart button is on screen, so it never covers the bundle options or the main button.
        if ("IntersectionObserver" in window) {
          this.kvVis = new Map();
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => this.kvVis.set(entry.target, entry.isIntersecting));
              const anyVisible = [...this.kvVis.values()].some(Boolean);
              const show = !anyVisible;
              this.container.style.setProperty("--m-translate-y", show ? 0 : "100%");
              this.container.classList.toggle("kv-satc--show", show);
              document.documentElement.classList[show ? "add" : "remove"]("stick-atc-show");
            },
            { threshold: 0, rootMargin: `-${headerHeight}px 0px -90px 0px` }
          );
          const kb = document.querySelector("[id*='kaching_bundles_app_block'], .shopify-app-block[id*='kaching']");
          if (kb) this.observer.observe(kb);
        }
        this.container.style.setProperty("--m-translate-y", "100%");

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();
        this.bindKvProxy();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker = this.mainProduct.querySelector('variant-picker');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
          this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options.split(',').filter(id => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });
      }

      // Kalvessa CRO: the sticky button re-uses the main Add-to-cart button, so the Kaching
      // bundle bar that is selected (Buy 1/2/3 + per-bar variants) is what gets added.
      // If the main button can't be used, scroll back to the bundle widget instead.
      bindKvProxy() {
        const btn = this.querySelector("[data-kv-sticky-atc]");
        if (!btn || btn.dataset.kvBound) return;
        btn.dataset.kvBound = "1";
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const main = this.mainAddToCart;
          const target = document.querySelector("[id*='kaching_bundles_app_block'], .kaching-bundles__block") || this.mainProductForm;
          // Kalvessa CRO 2026-10-18: if Kaching pre-selects a multi-unit bar and the shopper hasn't seen the
          // bundle options yet, show them first instead of silently adding 2+ units.
          if (target && !this.kvSeenDeals && this.kvPreselectedQty() > 1 && target.getBoundingClientRect().bottom > window.innerHeight) {
            this.kvSeenDeals = true;
            const top = target.getBoundingClientRect().top + window.scrollY - (MinimogSettings.headerHeight || 66) - 12;
            window.scrollTo({ top, behavior: "smooth" });
            return;
          }
          if (main && !main.disabled && !main.classList.contains("disabled")) {
            main.click();
          } else if (target) {
            const top = target.getBoundingClientRect().top + window.scrollY - (MinimogSettings.headerHeight || 66) - 12;
            window.scrollTo({ top, behavior: "smooth" });
          }
        }, true);
      }

      kvPreselectedQty() {
        try {
          const el = document.querySelector("script.kaching-bundles-deal-block-settings");
          if (!el) return 1;
          const d = JSON.parse(el.textContent);
          const bar = (d.dealBars || []).find((b) => b.id === d.preselectedDealBarId);
          return bar ? Number(bar.quantity) || 1 : 1;
        } catch (e) { return 1; }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');

        pickerFields.value = '';
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            const lbl = this.querySelector("[data-kv-satc-variant]");
            if (lbl) lbl.textContent = this.currentVariant.title;
            const box = this.querySelector(".m-sticky-addtocart--image");
            const fm = this.currentVariant.featured_image || (this.currentVariant.featured_media && this.currentVariant.featured_media.preview_image);
            if (box && fm && fm.src) {
              const im = document.createElement("img");
              im.src = fm.src + (fm.src.includes("?") ? "&" : "?") + "width=200";
              im.alt = ""; im.width = 100; im.height = 100;
              im.style.cssText = "width:100%;height:100%;object-fit:cover;border-radius:6px;display:block;aspect-ratio:1/1";
              box.replaceChildren(im);
            }
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
          } else {
            variantInput.value = '';
            this.toggleAddButton(true, window.MinimogStrings.unavailable)
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}
